// extracted by mini-css-extract-plugin
module.exports = {"header":"Donations_header__tPhJC","details":"Donations_details__KtPQ6","empty":"Donations_empty__2DTUL"};